<!-- @format -->

<span
	hmf-action-text
	id="pdp-change-store-link"
	class="change-store-link"
	variant="secondary"
	[ngClass]="{
		disabled: isDisabled || !storeSelectionReady
	}"
	(click)="openChangeStorePanel()">
	<span
		[ngClass]="{
			'hmf-body-m-l': isSubtext,
			'hmf-subheader-m-m': !isSubtext
		}">
		<ng-content></ng-content>
	</span>
</span>
